export const SCROLLED_CID = 'scrolledCid';
export const SCROLLED_SUBCAT_ID = 'scrolledSubcatId';
export const SCROLL_Y_POSITION = 'scrollYPosition';
